import React from 'react'
import { Modal } from '../../../components/Modal/Modal'
import { Col, Container, Row } from 'react-bootstrap'
import { useCreateScorecardMutation } from '../../../store/ai/scorecard'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { Scorecard, ScorecardType } from '../../../models/Scorecard'
import { useTracking, TrackEvent } from '../../../apps/professional-app/fa/common/tracking'
import { useLazyGetFeatureByIdQuery } from '../../../store/ai/ai'

export interface CloneFormModalProps {
  show: boolean
  onHide: () => void
  form: Scorecard | null
}

export const CloneFormModal: React.FC<CloneFormModalProps> = ({ show, onHide, form }) => {
  const accountId = useAppSelector(selectAccountId)
  const [createScorecard, { isLoading }] = useCreateScorecardMutation()
  const [getFeatureById] = useLazyGetFeatureByIdQuery()
  const { tracked } = useTracking()

  const _handleCopyForm = async () => {
    if (form) {
      const { data: feature } = await getFeatureById({
        accountId: accountId,
        aiFeatureId: form.aiFeatureIds[0],
      })
      const integrationInfos = feature?.data.integrationInfos?.[0]?.fieldConfig ? feature.data.integrationInfos : null
      await createScorecard({
        accountId: accountId,
        payload: {
          name: `Copy of ${form?.name}`,
          description: form?.description,
          descriptor: form?.descriptor,
          type: ScorecardType.FORM,
          config: {
            userLevel: form?.config.userLevel,
          },
          integrationInfos,
        },
      })
      onHide()
    }
  }

  const handleCopyForm = tracked(_handleCopyForm, {
    eventName: TrackEvent.FORM_CLONED,
    eventDetails: {
      formId: form?.id,
    },
  })

  const modalBody = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Clone Form</h4>
        </Col>
      </Row>
      <Row className='d-flex justify-content-center align-items-center text-center'>
        <Col className='p-0'>
          <div className='paragraph-medium'>Do you want to clone: {form?.name} ?</div>
        </Col>
      </Row>
    </Container>
  )

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={modalBody}
      showFooterActions
      footerPrimaryActionTitle='Clone'
      footerPrimaryActionButtonVariant='primary'
      footerPrimaryActionLoading={isLoading}
      onFooterPrimaryAction={handleCopyForm}
    />
  )
}
